module.exports = __webpack_public_path__ + "img/top.c482e361.c482e361.png";